'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var Slide = require('@material-ui/core/Slide');
var Button = require('@material-ui/core/Button');
var useDimensions = require('../useDimensions/useDimensions.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Slide__default = /*#__PURE__*/_interopDefaultLegacy(Slide);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

var useStyles = styles.makeStyles(theme => ({
  root: {
    position: 'relative',
    // left: '50%',
    // transform: 'translateX(-50%)',
    width: '100%',
    height: 120
  },
  card: {
    zIndex: 9999,
    position: 'fixed',
    bottom: 32,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[4],
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  }
}));
var SaveButtonsDialog = _ref => {
  var {
    isIn = false,
    onCancel,
    onSave,
    children
  } = _ref;
  var classes = useStyles();
  var [ref, dim] = useDimensions.useDimensions();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.root,
    ref: ref
  }, /*#__PURE__*/React__default['default'].createElement(Slide__default['default'], {
    in: isIn,
    direction: "up"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.card,
    style: {
      width: dim.width - 48,
      left: dim.left + 24
    }
  }, children !== null && children !== void 0 ? children : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    onClick: onCancel
  }, "Discard Changes"), /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      flex: 1
    }
  }), /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    variant: "contained",
    color: "primary",
    onClick: onSave
  }, "Save Changes")))));
};
SaveButtonsDialog.propTypes = {
  isIn: index.bool,
  onCancel: index.func,
  onSave: index.func,
  children: index.node
};

exports.SaveButtonsDialog = SaveButtonsDialog;
exports.default = SaveButtonsDialog;
